import { _ } from "libs";
import React, { useEffect, useState } from "react";
import ReservationsList from "./reservationsList";
import { Reservation } from "../types";
import withRedux from "../withRedux";
import { getActiveReservations } from "../actions";
import { Link } from "react-router-dom";
import ErrorBoundary from "./errorBoundary";
import { AuthState } from "../reducers/auth";
import { RootState } from "../reducers";

const initialState = {
	reservations: [],
	count: 0,
};

type Props = {
	auth: AuthState;
	params?: any;
	label?: string;
};

const UpcomingReservations = ({ auth, params, label }: Props) => {
	const [state, setState] = useState(initialState);
	const [filterParams, setFilterParams] = useState(null as any);

	useEffect(() => {
		let unmounted = false;
		//avoid constant reloading of reservations
		if (!filterParams || filterParams?.championshipId !== params?.championshipId) {
			setFilterParams(params);
		} else {
			return;
		}
		if (!unmounted) {
			getActiveReservations()
				.then(({ reservations }: { reservations: Reservation[] }) => {
					const filteredReservations = filterReservations(reservations, params);
					if (!filteredReservations) return;
					setState({ reservations: filteredReservations.slice(0, 3), count: filteredReservations.length });
				})
				.catch((error) => {
					console.log({ error });
				});
		}
		return () => {
			unmounted = true;
		};
	}, [params]);

	const filterReservations = (reservations, filterParams): Reservation[] => {
		if (!filterParams) {
			return reservations;
		}

		if (filterParams && Object.keys(filterParams).length === 0) {
			return reservations;
		}

		return reservations.filter((r) => {
			if (!filterParams?.championshipId) {
				return r;
			}
			return r?.championship?.uuid === filterParams?.championshipId;
		});
	};

	return (
		<ErrorBoundary>
			{state.count > 0 ? (
				<div className="nBlock upcomingReservations">
					<h5>{label || _("timeline.upcomingReservations")}</h5>
					<ReservationsList
						userId={auth.userId}
						reservations={state.reservations}
						dashboardMode={true}
						loading={false}
					/>
					{state.count > 3 ? (
						<div className="mt-4 mb-3">
							<Link to={"/reservations/active"} className="link seeMore">
								{_("timeline.seeAllUpcomingReservationsBtn")}
							</Link>
						</div>
					) : null}
				</div>
			) : null}
		</ErrorBoundary>
	);
};

const mapStateToProps = ({ auth }: RootState, ownProps) => {
	return { auth };
};

export default withRedux({}, mapStateToProps)(UpcomingReservations);
